/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookNotepadIcon20Light = forwardRef('BookNotepadIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9 6a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H9Z" }),
        React.createElement("path", { d: "M8.5 8.5A.5.5 0 0 1 9 8h4a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M9 10a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H9Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h7ZM4 5a2 2 0 0 1 2-2v14a2 2 0 0 1-2-2V5Zm3-2v14h6a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H7Z" })));
});
